export default class CookieHelper {
    static has(name) {
        return document.cookie.split(';')
            .some((item) => item.trim().startsWith(`${name}=`));
    }

    static get(name) {
        const value = document.cookie
            .split('; ')
            .find((row) => row.startsWith(`${name}=`))
            ?.split('=')[1];
        return value ? decodeURIComponent(value) : null;
    }

    static set(key, value, settings) {
        if (typeof key === 'undefined') {
            return false;
        }

        const defaults = {
            path: '/',
            expires: undefined,
            domain: undefined,
            secure: false,
            trimUndefined: true,
        };

        const type = typeof value;
        const options = Object.assign(defaults, settings);
        const cookieValue = (options.trimUndefined && (type === 'undefined' || type === 'null')) ? '' : value;

        if (options.expires && typeof options.expires === 'number') {
            const expires = new Date();
            expires.setDate(expires.getDate() + options.expires);
            options.expires = expires;
        } else if (!(options.expires instanceof Date)) {
            options.expires = undefined;
        }

        /* create and set cookie */
        const cookie = [
            encodeURIComponent(key), '=', encodeURIComponent(cookieValue),
            options.expires ? (`; expires=${options.expires.toUTCString()}`) : '',
            options.domain ? (`; domain=${options.domain}`) : '',
            options.path ? (`; path=${options.path}`) : '',
            options.secure ? '; secure' : '',
        ].join('');

        window.document.cookie = cookie;

        return cookie;
    }

    static remove(name, path) {
        document.cookie = `${name}=; path=${path || '/'}; domain=${window.location.host}; Max-Age=-1`;
    }
}
